<script>
	module.exports = {
		props: {
			items: {
				default: null
			},
			emptyItem: {
				default: null
			},
			onSuggestionClick: {
				default() {},
				type: Function
			},
			onTokenClick: {
				default() {},
				type: Function
			},
			placeholder: {
				default: 'Add more...'
			},
			emptyPlaceholder: {
				default: null
			}
		},
		components: {
			'search-bar-with-suggestions': require('components/search-bar-with-suggestions.vue').default
		},
		data() {
			return {
				query: ''
			};
		},
		computed: {
			searchableNodes() {
				let items = this.items || [];
				return items.filter(i => !i.selected);
			},
			selectedItems() {
				let items = this.items || [];
				return items.filter(i => i.selected);
			},
			searchPlaceholder() {
				let placeholder = this.placeholder;
				let emptyPlaceholder = this.emptyPlaceholder;
				let selectedItems = this.selectedItems;

				if (selectedItems.length < 1 && emptyPlaceholder) {
					placeholder = emptyPlaceholder;
				}
				return placeholder;
			}
		},
		methods: {
			onFocus() {
				let searchBar = this.$refs.searchBar;
				if (searchBar) {
					$('input.validated-input', searchBar.$el).focus();
				}
			},
			onSuggestionClickInternal() {
				this.query = '';
				if (this.onSuggestionClick) {
					this.onSuggestionClick(...arguments);
				}
			},
			onTokenClickInternal() {
				if (this.onTokenClick) {
					this.onTokenClick(...arguments);
				}
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.token-field {
		background-color: white;
		border-radius: 4px;
		padding: 0.25rem;

		.selected-tokens-list {
			.selected-token {
				background-color: $c-blue-notif;
				margin-right: 0.25rem;
				margin-bottom: 0.25rem;
				font-weight: bold;
				color: $c-slate-dark;

				i.close-icon {
					font-size: 1.25rem;
					margin-left: 0.5rem;
					line-height: 1rem;
				}
			}
		}

		.search-bar-with-suggestions {
			input.input.validated-input {
				border: none;
				padding: 0.25rem;
				min-height: 1.5rem;
			}
		}
	}
</style>
<template>
	<div
		class="token-field"
		tab-index="-1"
		@click="onFocus">
		<div
			class="selected-tokens-list pills"
			v-if="selectedItems.length || emptyItem">
			<li
				v-for="item in selectedItems"
				:key="item.text"
				class="selected-token pill"
				@click="onTokenClickInternal(item, $event)">
				{{ item.text }}
				<i
					class="close-icon"
					aria-hidden="true"
					>×</i
				>
			</li>
			<li
				v-if="!selectedItems.length && emptyItem"
				class="selected-token pill">
				{{ emptyItem.text }}
			</li>
		</div>
		<search-bar-with-suggestions
			ref="searchBar"
			:value="query"
			@input.native="query = $event.target.value"
			:search-domain="searchableNodes"
			:on-suggestion-click="onSuggestionClickInternal"
			:minimum-characters-for-suggestions="0"
			:show-keyword-option="false"
			:placeholder="searchPlaceholder"
			:show-suggestions-on-focus="true"
			maxlength="256">
		</search-bar-with-suggestions>
	</div>
</template>
